export default __webpack_public_path__ + "static/media/pencil-disabled.bd70b455.svg";